var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 421,
    viewBox: "0 0 582 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M462.597 150.353L576.726 84.1411L498.348 40.5195L390.043 104.331",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.035 104.331L388.305 105.348",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.933 107.334L325.922 142.103",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10,
    strokeDasharray: "6.09 6.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.234 143.098L322.504 144.115L324.24 145.12",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.672 147.1L394.694 185.744",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10,
    strokeDasharray: "6.09 6.09"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.418 186.73L398.154 187.736L399.891 186.73",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M403.477 184.646L459.057 152.399",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10,
    strokeDasharray: "6.09 6.09"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M460.852 151.359L462.588 150.354",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322.504 374.48L398.153 418.095L576.721 314.5L498.343 270.885L322.504 374.48Z",
    stroke: "#231F20",
    strokeWidth: 2.0044,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M322.938 374.48L398.587 418.095L577.149 314.5L498.776 270.885L322.938 374.48Z",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M398.156 302.097V418.096",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M497.664 40.5195V270.885",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M576.645 84.0674V314.427",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M322.504 261.607V373.72",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M322.504 143.359V261.607",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10,
    strokeDasharray: "6.09 6.09"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.181 167.717C145.037 167.717 160.323 152.431 160.323 133.575C160.323 114.719 145.037 99.4336 126.181 99.4336C107.325 99.4336 92.0391 114.719 92.0391 133.575C92.0391 152.431 107.325 167.717 126.181 167.717Z",
    fill: "#F8EB30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M375.111 302.633L390.037 311.229L390.007 351.945L374.812 342.879L375.111 302.633Z",
    stroke: "white",
    strokeWidth: 1.00525,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M353.982 290.022L368.908 298.619L368.878 339.34L353.684 330.275L353.982 290.022Z",
    stroke: "white",
    strokeWidth: 1.00525,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M333.736 277.44L348.662 286.037L348.632 326.758L333.438 317.693L333.736 277.44Z",
    stroke: "white",
    strokeWidth: 1.00525,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M375.111 351.945L390.037 360.548L390.007 401.263L374.812 392.198L375.111 351.945Z",
    stroke: "white",
    strokeWidth: 1.00525,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M353.982 339.34L368.908 347.936L368.878 388.652L353.684 379.586L353.982 339.34Z",
    stroke: "white",
    strokeWidth: 1.00525,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M333.736 326.759L348.662 335.355L348.632 376.071L333.438 367.005L333.736 326.759Z",
    stroke: "white",
    strokeWidth: 1.00525,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M428.953 285.544L399.033 302.797L328.41 261.826L359.408 244.572L428.953 285.544Z",
    fill: "#F8EB30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M458.1 228.02L428.174 245.274L357.551 204.296L388.549 187.049L458.1 228.02Z",
    fill: "#F8EB30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1 62.7763C5.088 62.7763 370.577 266.512 370.577 266.512L555.78 0.633789",
    stroke: "#F8EB30",
    strokeWidth: 2.0044,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M398.152 302.798V418.096",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M398.152 187.737V302.798",
    stroke: "white",
    strokeWidth: 4.01489,
    strokeMiterlimit: 10,
    strokeDasharray: "6.09 6.09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.236d21e22bb88b423fb8a36e0badfe0b.svg";
export { ForwardRef as ReactComponent };